
export default {
  first: {
    title: '看点课堂-在职提升学习平台，为您提供心理课程 | 人力资源课程 | 理财课程 | 短视频电商课程 | 在职研课程',
    meta: [
      {
        name: 'keywords',
        content: '心理训练营，人力资源，小白理财，理财课程，抖音、快手短视频课程，在职研课程，国际MBA课程等。'
      },
      {
        name: 'description',
        content: '看点课堂为每一位学员提供高质量的学历提升以及职场晋级课程，涵盖心理、人力、短视频、理财、在职研、国际MBA等课程。'
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/vue-meta-info.js